export const title = 'Leap Into Training';
export const blurb =
  'SAVE 29% on any single classroom training course when you register in February with the discount code, “LEAPYEAR29”';
export const second_copy =
  'Cannot be combined with any other discount. Does not apply to custom training, non-North American, or SafeBridge courses.';
